// extracted by mini-css-extract-plugin
export default {"iframeContainer":"embed-block_iframeContainer__pVNUj"};